import { useState } from 'react';

export default function AppSection() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              随时随地 想追就追
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              久久影视已适配手机、平板等移动设备，无论你在地铁上、午休时还是睡前，
              打开浏览器就能快速浏览最新影视动态。高清不卡，流畅追剧，把好内容装进口袋。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer">
                <i className="ri-smartphone-line"></i>
                手机端追剧
              </div>
              <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-200 text-foreground-700 font-medium text-sm whitespace-nowrap cursor-pointer">
                <i className="ri-tablet-line"></i>
                平板端浏览
              </div>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            {!imgError ? (
              <div className="w-full max-w-[300px] aspect-[9/16] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20movie%20and%20TV%20show%20browsing%20interface%2C%20clean%20dark%20theme%20UI%20design%2C%20film%20posters%20on%20screen%2C%20warm%20ambient%20background%2C%20product%20photography%20style%2C%20professional%20lighting%2C%20premium%20device%20presentation&width=600&height=1067&seq=app-mobile-mockup&orientation=portrait"
                  alt="久久影视移动端追剧"
                  className="w-full h-full object-cover object-top rounded-lg"
                  onError={() => setImgError(true)}
                />
              </div>
            ) : (
              <div className="w-full max-w-[300px] aspect-[9/16] rounded-lg bg-background-200 flex items-center justify-center">
                <i className="ri-smartphone-line text-5xl text-foreground-300"></i>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}